module.exports = __webpack_public_path__ + "UX29.png?e766435938edc4b37c5b1656816a6711";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX29.png
// module id = 78
// module chunks = 0